import xlsx from 'json-as-xlsx';

export function excelExport(params: {
    fileName: string;
    sheetName: string;
    columns: string[];
    content: any[];
}) {
    const settings = {
        fileName: params.fileName,
        sheetName: params.sheetName,
    };

    const exportColumns = params.columns.map((column) => ({
        label: column,
        value: column,
    }));
    const download = true;

    xlsx(exportColumns, params.content, settings, download);
}
